<template>
    <v-menu
            ref="menu"
            lazy
            :close-on-content-click="false"
            v-model="menu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
    >
        <v-text-field
                slot="activator"
                :label="label"
                v-model="date"
                prepend-icon="event"
                readonly
                :rules="rules"
                :required="required"
        ></v-text-field>
        <v-date-picker
                ref="picker"
                v-model="date"
                locale="es-es"
                @change="save"
                min="1950-01-01"
                :max="new Date().toISOString().substr(0, 10)"
        ></v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: "date-input",
        props: ['rules', 'required', 'label'],
        data: () => ({
            menu: false,
            date: null,
        }),
        watch: {
            menu (val) {
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
            date (val){
                console.log(val)
                this.$emit('input', val)
            }
        },
        methods: {
            save (date) {
                this.$refs.menu.save(date)
            }
        },

    }
</script>

<style scoped>

</style>